module.exports = __webpack_public_path__ + "favicon-114-bd4edb383f12a15952eaf9bee0edd85a.bundle.png";